<template>
    <div class="super-admin-students">
        <PreLoader v-if="isLoading"/>
        <SuperAdminSchoolHead>
            <template v-slot:title>{{ $t('students') }}</template>
            <template v-slot:right>
                <div class="export-custom">
                    <ExcelJs ref="exportStudents" :buttonTitle="$t('exportStudents')"
                             :file-name="$t('allStudents')" :headers="exportStudentHeaders" :rows="exportStudentRows"/>
                    <span class="export-custom-btn" @click="exportAllStudents"></span>
                </div>
            </template>
<!--            <template v-slot:center>-->
<!--                <div style="display: flex; gap: 8px">-->
<!--                    <v-text-field outlined dense v-model="filterObj.searchRequest['query']" @keyup.enter="searchStudentByFIO"-->
<!--                                  @input="filterObj.searchRequest.query !== '' ? showIcon = true : showIcon = false"-->
<!--                                  prepend-inner-icon="mdi-magnify"-->
<!--                                  :append-icon="!showIcon ? '' : 'mdi-close'" @click:append="clearSearch"/>-->
<!--                    <v-btn color="primary" style="height: 40px; margin: 0" class="text-no-wrap"-->
<!--                           @click="searchStudentByFIO">-->
<!--                        {{$t("search")}}-->
<!--                    </v-btn>-->
<!--                </div>-->
<!--                <SmartSearchInput :searchObj="filterObj.searchRequest" :searchField="'query'"-->
<!--                                  @onEnter="searchStudentByFIO"/>-->
<!--                <button class="search-btn" @click="searchStudentByFIO">{{ $t('search') }}</button>-->
<!--            </template>-->
        </SuperAdminSchoolHead>
        <SmartTable :current-page="currentPage" :page-size="pageSize" :schools="students"
                    :total-elements="totalElements" :totalPages="totalPages" @leftClick="onLeftClick"
                    @rightClick="onRightClick">
            <template v-slot:firstItem>
                <div class="select-filter-block" style="align-items: flex-start">
                    <div class="selects">
                        <div class="select-clear-block">
                            <v-select :items="currentRegions" item-text="title" item-value="id"
                                      :label="$t('region')" v-model="filterObj.searchRequest.regionId"
                                      @change="fetchRayonsByRegion" :no-data-text="$t('no_data')"
                                      outlined dense @click:append-outer="filterObj.searchRequest.regionId=''"
                                      :append-outer-icon="filterObj.searchRequest.regionId !== '' ? 'mdi-delete-outline' : ''"/>
                        </div>
                        <div class="select-clear-block">
                            <v-select :items="filteredRayons" item-text="title" item-value="id"
                                      :label="$t('district')" v-model="filterObj.searchRequest.rayonId"
                                      @change="onSelectRayon" :no-data-text="$t('no_data')"
                                      outlined dense @click:append-outer="filterObj.searchRequest.rayonId=''"
                                      :append-outer-icon="filterObj.searchRequest.rayonId !== '' ? 'mdi-delete-outline' : ''"/>
                        </div>
                        <div class="select-clear-block">
                            <v-select :items="filteredSchools" item-text="nameRu" item-value="id"
                                      :label="$t('school')" v-model="filterObj.searchRequest.schoolId"
                                      :menu-props="{contentClass: 'schoolSelect'}" :no-data-text="$t('no_data')"
                                      @click="addScrollListenerSchoolSelect" @blur="removeSchoolSelectScrollListener"
                                      outlined dense @click:append-outer="filterObj.searchRequest.schoolId=''"
                                      :append-outer-icon="filterObj.searchRequest.schoolId !== '' ? 'mdi-delete-outline' : ''"/>
                        </div>
                        <div class="select-clear-block">
                            <v-select :items="classes" item-text="classLevel" item-value="classLevel"
                                      :label="$t('class')" v-model="filterObj.searchRequest.classLevel"
                                      @change="onSelectRayon" :no-data-text="$t('no_data')"
                                      outlined dense @click:append-outer="filterObj.searchRequest.classLevel=''"
                                      :append-outer-icon="filterObj.searchRequest.classLevel !== '' ? 'mdi-delete-outline' : ''"/>
                        </div>
                    </div>
                    <div class="btn-filter">
                        <v-btn color="primary" style="height: 40px" @click="filterStudents">{{$t('show')}}</v-btn>
                    </div>
                </div>
            </template>
            <template v-slot:head>
                <th>{{ $t('school') }}</th>
                <th>{{ $t('full_name') }}</th>
                <th>{{ $t('gender') }}</th>
                <th>{{ $t('class') }}</th>
                <th>{{ $t('birthDate') }}</th>
                <th>{{ $t('district') }}</th>
            </template>

            <template v-slot:body="{ item }">
                <td>{{ item.schoolTitle }}</td>
                <td>{{ item.surname }} {{ item.name }}</td>
                <td>{{ gender[item.gender] }}</td>
                <td>{{ item.classTitle }}</td>
                <td>{{ formatDOB(item.dateOfBirth) }}</td>
                <td>{{ item.rayonTitle }}</td>
            </template>
        </SmartTable>
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import { StudentService } from '@/_services/student.service'
import PreLoader from '@/components/preloader/PreLoader'
import { RayonService } from '@/_services/rayon.service'
import { SchoolService } from '@/_services/school.service'
import ExcelJs from '@/components/excel-export/ExcelJs'
import moment from 'moment'
const studentService = new StudentService()
const rayonService = new RayonService()
const schoolService = new SchoolService()

export default {
  name: 'Students',
  components: {
    SmartTable,
    SuperAdminSchoolHead,
    PreLoader,
    ExcelJs
  },
  data () {
    return {
      totalPages: 1,
      students: [],
      totalElements: 0,
      pageSize: 20,
      currentPage: 1,
      gender: {
        1: 'Ж',
        0: 'М'
      },
      isLoading: false,
      showIcon: false,
      filterObj: {
        pageRequest: {
          limit: 10,
          offset: 0
        },
        searchRequest: {
          classLevel: '',
          query: '',
          rayonId: '',
          regionId: '',
          schoolId: ''
        }
      },
      classes: [],
      filteredRayons: [],
      filteredSchools: [],
      exportStudentHeaders: [],
      exportStudentRows: []
    }
  },
  computed: {
    currentRegions () {
      return this.$store.state.location.regions
    }
  },
  mounted () {
    // this.fetchStudents(0)
    this.classes = [
      { classLevel: 1 }, { classLevel: 2 }, { classLevel: 3 }, { classLevel: 4 }, { classLevel: 5 }, { classLevel: 6 },
      { classLevel: 7 }, { classLevel: 8 }, { classLevel: 9 }, { classLevel: 10 }, { classLevel: 11 }
    ]
  },
  methods: {
    fetchStudents () {
      this.isLoading = true
      studentService.getAllStudents(this.filterObj).then((res) => {
        this.pageSize = this.filterObj.pageRequest.limit
        this.totalElements = res.totalCount
        this.totalPages = Math.ceil(res.totalCount / this.filterObj.pageRequest.limit)
        this.students = res.list
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    exportAllStudents () {
      this.isLoading = true
      this.filterObj.pageRequest.offset = 0
      this.filterObj.pageRequest.limit = this.totalElements
      studentService.getAllStudents(this.filterObj).then((res) => {
        if (res.list.length) {
          this.exportStudentHeaders = [this.$t('school'), this.$t('district'), this.$t('full_name'), this.$t('class'),
            this.$t('birthDate'), this.$t('gender')]
          this.exportStudentRows = res.list.map((i) => {
            return [
              i.schoolTitle,
              i.rayonTitle,
              i.surname + ' ' + i.name,
              i.classTitle,
              this.formatDOB(i.dateOfBirth),
              i.gender ? 'Ж' : 'М'
            ]
          })
          this.$refs.exportStudents.isExport = true
        }
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },

    formatDOB (date) {
      return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY')
    },

    onLeftClick () {
      this.currentPage--
      this.filterObj.pageRequest.offset = this.currentPage - 1
      this.fetchStudents()
    },

    onRightClick () {
      this.currentPage++
      this.filterObj.pageRequest.offset = this.currentPage - 1
      this.fetchStudents()
    },

    filterStudents () {
      if (!this.filterObj.searchRequest.regionId) {
        this.$toast.info('Выберите область')
        return
      }
      if (!this.filterObj.searchRequest.rayonId) {
        this.$toast.info('Выберите район')
        return
      }
      if (!this.filterObj.searchRequest.schoolId) {
        this.$toast.info('Выберите школу')
        return
      }
      this.currentPage = 1
      this.filterObj.searchRequest.query = ''
      this.filterObj.pageRequest.offset = this.currentPage - 1
      this.fetchStudents()
    },

    fetchRayonsByRegion (regionId) {
      this.filterObj.searchRequest.schoolId = ''
      this.filterObj.searchRequest.rayonId = ''
      this.filteredSchools = []
      rayonService.listByRegion(regionId).then((res) => {
        this.filteredRayons = res
      })
    },

    onSelectRayon () {
      this.filteredSchools = []
      // this.filterObj.searchRequest.schoolId = ''
      this.schoolPage = 0
      this.fetchSchoolsByRayon()
    },

    fetchSchoolsByRayon () {
      schoolService.listPageable(
        this.schoolPage,
        this.filterObj.searchRequest.regionId,
        this.filterObj.searchRequest.rayonId
      ).then((res) => {
        if (res._embedded) {
          res._embedded.schoolResourceList.forEach((school) => {
            this.filteredSchools.push(school)
          })
        } else {
          this.removeSchoolSelectScrollListener()
        }
      })
    },

    searchStudentByFIO () {
      this.filterObj.searchRequest.schoolId = ''
      this.filterObj.searchRequest.classLevel = ''
      this.filterObj.searchRequest.regionId = ''
      this.filterObj.searchRequest.rayonId = ''
      this.currentPage = 1
      this.fetchStudents(0)
    },
    clearSearch () {
      this.showIcon = false
      this.filterObj.searchRequest.query = ''
      this.searchStudentByFIO()
    },

    addScrollListenerSchoolSelect () {
      this.$nextTick(() => {
        const schoolSelect = document.querySelector('.schoolSelect')
        schoolSelect.addEventListener('scroll', this.innerSelectScrollListener)
      })
    },

    innerSelectScrollListener () {
      const schoolSelect = document.querySelector('.schoolSelect')
      const almostEndOfScroll = (schoolSelect.scrollHeight - schoolSelect.clientHeight) - 100
      if (schoolSelect.scrollTop >= almostEndOfScroll) {
        this.schoolPage++
        this.fetchSchoolsByRayon()
      }
    },

    removeSchoolSelectScrollListener () {
      const schoolSelect = document.querySelector('.schoolSelect')
      if (schoolSelect) {
        schoolSelect.removeEventListener('scroll', this.innerSelectScrollListener)
      }
    }
  }
}
</script>

<style lang="scss">
.super-admin-students {
    margin-bottom: 50px;
    .select-filter-block {
        .selects {
            display: flex;
            flex-wrap: wrap;
            //max-width: 540px;
        }
    }
}
</style>
